import React, { FC } from 'react';

import { EmailIcon } from '@modernloop/shared/icons';
import { Chip, Stack } from '@mui/material';

import OptionalAttendeeToggle from 'src/entities/common/OptionalAttendeeToggle';

import { SmartEmployeeSelectChipAction } from './chipAction';
import { chipGroupSx } from './chipLayout';

type Props = {
  /** The email address to display */
  email: string;
  /** Callback fired when the delete icon is clicked */
  onDelete?: () => void;
  /** Opt-in required/optional control rendered inside the chip. Only attendee surfaces pass one. */
  action?: SmartEmployeeSelectChipAction;
};

/**
 * Renders a Chip displaying an external email address with an email icon.
 */
const SmartEmployeeSelectChipEmailAddress: FC<Props> = ({ email, onDelete, action }) => {
  const chip = (
    <Chip
      variant="filled"
      icon={<EmailIcon />}
      size="small"
      label={email}
      onDelete={onDelete}
      data-testid="smart-employee-select-chip-email"
    />
  );

  // Sibling, not nested: see SmartEmployeeSelectChipEmployee.
  return action ? (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={chipGroupSx}>
      {chip}
      <OptionalAttendeeToggle isAttendeeOptional={action.isOptional} onUserIconClick={action.onToggle} />
    </Stack>
  ) : (
    chip
  );
};

export default SmartEmployeeSelectChipEmailAddress;
